/* eslint-disable no-undef */
import React from 'react';
import { useSelector } from 'react-redux';

import { getInputIndex } from 'helpers/actionHelpers';
import Types from 'constants/types';

import ResourceLinkEdit from 'field/edit/resource/ResourceLinkEdit';
import Header from 'field/common/Header';
import EditLinkedResources from 'field/edit/resource/EditLinkedResources';

// Search Objects: adds parameters for Spectrum TargetTypes on modal open
const ObjectLinkEdit = (props) => {
  const field = props.field;
  const folder = useSelector(state => state.object.museum);

  const searchParameters = {
    constraint: 'museum->' + folder,
    searchView: 'object',
    topLevel: ['targetTypeTop'],
    searchKey: ['select_targetType_1'],
    searchValue: [''],
    operator: 'and',
  };

  const onEdit = e => {
    const index = getInputIndex(e);
    const uri = field.values[index].uri;
    window.open(`index.do?main_action=editObject.do?uri=${uri}`, '_blank');
  };
  
  return (
    <div className="field">
      <Header field={field} />
      <ResourceLinkEdit 
        searchParameters={searchParameters}
        {...props} />
      <EditLinkedResources 
        onEdit={onEdit}
        onRemove={field.removeResource}
        values={field.values} />
    </div>
  );
};

export default ObjectLinkEdit;